import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { PowerDialerAccessLayout } from 'pages/powerDialer/layout/powerDialerAccessLayout'
import { PowerDialerListPage } from 'pages/powerDialer/pages/list'
import { PowerDialerLayout } from 'pages/powerDialer/layout/PowerDialerLayout'
import { PowerDialerViewPage } from 'pages/powerDialer/pages/view'
import { PowerDialerRoutes } from 'pages/powerDialer/route/type'

export const PowerDialerRouter = observer(() => {
  return (
    <Routes>
      <Route element={<PowerDialerAccessLayout />}>
        <Route element={<PowerDialerLayout />}>
          <Route index element={<PowerDialerListPage />} />
          <Route path={`${PowerDialerRoutes.view}/:id`} element={<PowerDialerViewPage />} />
        </Route>
      </Route>
    </Routes>
  )
})
